// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_UrYy0","logo_2":"index_logo_2_iDiyE","ad_1":"index_ad_1_ErhoW","ad_2":"index_ad_2_F96cy"};